import { useState } from 'react';

import BpkLargeVdlCarsIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/vdl-cars';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import { logWarn } from 'saddlebag-logger';

import { COMPONENT_CAPYBARA_RECOMMENDATIONS } from '../../helpers/constants/analyticsConstants';
import { useTranslation } from '../../helpers/hooks/useTranslation';

import ProductLink from './ProductLink';

import type { CarHireInfo } from './types';

type CarHireSectionProps = {
  carHire: CarHireInfo;
  onLinkClick?: () => void;
};

const CarHireSection = ({ carHire, onLinkClick }: CarHireSectionProps) => {
  const translate = useTranslation();
  const [supplierLogoFailed, setSupplierLogoFailed] = useState(false);

  return (
    <div className="recommendation-card__product">
      <span className="recommendation-card__product-label">
        <BpkText textStyle={TEXT_STYLES.footnote}>
          {translate('ktxt_combo_rec_your_car')}
        </BpkText>
      </span>
      <div className="recommendation-card__car">
        {carHire.imageUrl ? (
          <img
            className="recommendation-card__car-image"
            src={carHire.imageUrl}
            alt={carHire.name}
          />
        ) : (
          <span className="recommendation-card__car-image-fallback">
            <BpkLargeVdlCarsIcon aria-hidden="true" />
          </span>
        )}
        <div className="recommendation-card__car-info">
          <BpkText
            textStyle={TEXT_STYLES.label2}
            tagName="span"
            className="recommendation-card__car-name"
          >
            {carHire.name}
          </BpkText>
          <div className="recommendation-card__car-supplier">
            {carHire.supplierLogoUrl && !supplierLogoFailed && (
              <img
                className="recommendation-card__supplier-logo"
                data-testid="supplier-logo"
                src={carHire.supplierLogoUrl}
                alt=""
                aria-hidden="true"
                title={carHire.name}
                onError={() => {
                  logWarn({
                    component: COMPONENT_CAPYBARA_RECOMMENDATIONS,
                    message: 'Failed to load supplier logo',
                    supplierLogoUrl: carHire.supplierLogoUrl ?? '',
                  });
                  setSupplierLogoFailed(true);
                }}
              />
            )}
          </div>
        </div>
      </div>
      <ProductLink
        label={translate('ktxt_combo_rec_car_from_price', {
          price: carHire.priceFormatted,
        })}
        href={carHire.onClickUrl}
        onClick={onLinkClick}
      />
    </div>
  );
};

export default CarHireSection;
